import 'dom-shims';
import 'mdn-polyfills/Array.from';
import 'mdn-polyfills/Array.prototype.find';
import 'mdn-polyfills/Array.prototype.findIndex';
import 'mdn-polyfills/Array.prototype.includes';
import 'mdn-polyfills/Object.assign';
import 'mdn-polyfills/String.prototype.padEnd';
import 'mdn-polyfills/String.prototype.padStart';


/* tslint:disable:no-bitwise */

/***
* Object.value Polyfill
* author: John Chappell
**/

if (!Object.values) {
	Object.values = function <T>(o: { [s: string]: T }): T[] {
		return Object.keys(o).map((key) => o[key]) || [];
	};
}

/***
* Number.parseInt Polyfill
* source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/parseInt#Polyfill
**/

if (Number.parseInt === undefined) {
	Number.parseInt = (window as any).parseInt;
}

/***
* ChildNode.remove Polyfill
* source: https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove#Polyfill
**/
(function(arr) {
	arr.forEach(function(item) {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				if (this.parentNode !== null) {
					this.parentNode.removeChild(this);
				}
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
